import { render, staticRenderFns } from "./NewsletterRegistration.vue?vue&type=template&id=9420586a&"
import script from "./NewsletterRegistration.vue?vue&type=script&lang=js&"
export * from "./NewsletterRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports